import { curry, pipe, fromPairs } from 'ramda';

const arr2obj = curry((fn, arr) =>
  pipe(
    list => list.map(k => [k.toString().toLowerCase(), fn(k)]),
    fromPairs,
  )(arr));

export const regions = ['northAmerica', 'europe', 'asia', 'oceania', 'africa', 'southAmerica'];

export const regionText = ['North America', 'Europe', 'Asia', 'Oceania', 'Africa', 'South America'];

export const getRegion = (name) => {
  const sanitizedName = name.toLowerCase().replace('delay_index_', '').replace('_', '');
  const primaryRegions = arr2obj(k => k, regions);
  const map = {
    unitedkingdom: 'europe',
    japan: 'asia',
    usfaa: 'northAmerica',
    faa: 'northAmerica',
    ...primaryRegions,
  };
  return map[sanitizedName];
};



// WEBPACK FOOTER //
// ./modules/AirportDelayMap/components/regions.js